import { render, staticRenderFns } from "./ChenWuPage.vue?vue&type=template&id=49cc0622&scoped=true"
import script from "./ChenWuPage.vue?vue&type=script&lang=js"
export * from "./ChenWuPage.vue?vue&type=script&lang=js"
import style0 from "./ChenWuPage.vue?vue&type=style&index=0&id=49cc0622&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49cc0622",
  null
  
)

export default component.exports